import debounce from "../../custom_js/debounce";
import showToast from "../../custom_js/showToast";

up.compiler(".up_harvest", function (element) {
  const input = element.querySelector("input");

  function onInputChanged() {
    let newValue = input.value;
    let theInt = 0;
    let theDec = 0;

    // Nettoie tout ce qui n'est pas chiffre ou point
    newValue = newValue.replace(/[^\d.]/g, "");

    // N'autorise qu'un seul point
    const parts = newValue.split(".");
    if (parts.length > 2) {
      newValue = parts[0] + "." + parts.slice(1).join("");
    }
    // Limiter à 2 décimales après le point
    if (parts.length === 2) {
      parts[1] = parts[1].slice(0, 2);
      newValue = parts[0] + "." + parts[1];
    }
    input.value = newValue;

    if (up.util.contains(newValue, ".")) {
      // Décimal
      theInt = newValue.split(".")[0];
      theDec = newValue.split(".")[1];
    } else {
      // Entier
      theInt = newValue;
    }

    up.render({
      url: `/manage-workshops-harvest/${element.dataset.freskslug}/${element.dataset.workshopslug}?theInt=${theInt}&theDec=${theDec}`,
      method: "put",
      target: `.js-displayed-price.${element.dataset.workshopslug}`,
      history: false,
      focus: "#workshop_total_harvest",
    }).catch(() => {
      input.value = "";
      showToast("Erreur : veuillez contacter le support", "red", 4000);
    });
  }

  const debouncedOnInputChanged = debounce(onInputChanged, 100);

  input.addEventListener("input", debouncedOnInputChanged);

  return () => {
    input.removeEventListener("input", debouncedOnInputChanged);
  };
});
